import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillSocialVideosV1Request } from './backfill-social-videos-v1-request';
import type { IBackfillSocialVideosV1Response } from './backfill-social-videos-v1-response';
import { backfillSocialVideosV1ResponseSchema } from './backfill-social-videos-v1-response';

export async function backfillSocialVideosV1Api(
  body: IBackfillSocialVideosV1Request = {},
): Promise<IValidatedResponse<IBackfillSocialVideosV1Response>> {
  return postRequest<IBackfillSocialVideosV1Response>({
    path: '/sys/social/v1/library/backfill',
    body,
    schema: backfillSocialVideosV1ResponseSchema,
  });
}
